import styled from 'styled-components';
import { Form } from 'formik';
import {
  ButtonGroup,
  Label,
  Select,
  WarningNotice,
} from '@studio/legacy-components';

/**
 * CloneMobileFLow components
 */
export const CloneModalFlowForm = styled(Form)`
  margin-top: 8px;

  ${Label}:not(:first-child) {
    margin-top: 32px;
  }

  ${Select} {
    max-width: 100%;
  }

  ${ButtonGroup} {
    margin-top: 32px;
  }
`;

export const AppWarningNotice = styled(WarningNotice)`
  margin-top: 32px;

  > div {
    line-height: 21px;
  }
`;

export const FlowCardWrapper = styled.div``;
